import {
    Affix,
    Button,
    Card,
    Col,
    Collapse,
    DatePicker,
    Divider,
    FloatButton,
    Form,
    Input,
    message,
    Modal,
    Row,
    Select,
    Statistic,
    Table,
    Tag,
    Timeline
} from "antd";
import {trans_img} from "../../../../AppImageConst";
import React, {useEffect, useState} from "react";
import './styles.scss';
import {
    CloseCircleOutlined,
    CloseOutlined,
    DownloadOutlined,
    EllipsisOutlined,
    EyeOutlined,
    ReloadOutlined,
    SearchOutlined,
    SendOutlined,
    StopOutlined
} from "@ant-design/icons";
import {CheckCircleOutlined} from "@ant-design/icons/lib";
import {useHistory, useLocation, useParams} from "react-router-dom";
import transactionFetchService from "../../../service/transactionFetchService";
import {CommonAxiosSuccessResponseDto} from "../../../dto/CommonAxiosSuccessResponseDto";
import {TransactionHistoryWrapperDto} from "../../../dto/TransactionHistoryWrapperDto";
import ErrorHandler from "../../../util/ErrorHandler";
import Validation from "../../../util/Validation";
import CommonFunction from "../../../util/CommonFunction";
import dayjs from "dayjs";
import {
    COMMON_DROPDOWN,
    DIGITS_AND_DOT_VALIDATION,
    DOC_CODE_INVEST_TRANSACTION_DOCUMENT,
    DOC_CODE_SWITCH_TRANSACTION_DOCUMENT,
    DOC_CODE_TRANSFER_TRANSACTION_DOCUMENT,
    DOC_CODE_WITHDRAW_TRANSACTION_DOCUMENT,
    NEGATIVE_AMOUNT_VALIDATION,
    NOT_AVAILABLE,
    PARAMETER_LIST,
    PREVIEW_DOC_TYPES,
    YYYY_MM_DD,
    YYYY_MM_DD_HH_MM
} from "../../../util/Constants";
import {TransactionHistoryFilterDto} from "../../../dto/TransactionHistoryFilterDto";
import {NumericFormat} from "react-number-format";
import documentService from "../../../service/documentService";
import {UploadedDocumentDetailDto} from "../../../dto/UploadedDocumentDetailDto";
import {toNumber} from "lodash";
import {MSG_FAILED_TO_FETCH_DOCUMENTS_ERROR, MSG_FAILED_TO_FETCH_FUND_LIST_ERROR} from "../../../util/Messages";
import PreviewModalComp from "../../../components/common/preview/PreviewModalComp";
import customerService from "../../../service/customerService";
import {InputDropdownParameterDto} from "../../../dto/InputDropdownParameterDto";
import {DropdownListDto} from "../../../dto/DropdownListDto";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCircleLeft} from "@fortawesome/free-solid-svg-icons";
import {TransactionHistoryDto} from "../../../dto/TransactionHistoryDto";
import {AccountWiseFundDetailDto} from "../../../dto/AccountWiseFundDetailDto";

const {RangePicker} = DatePicker;

const ROUTER_PARAM_ALL_TRANSACTIONS = "all-transactions"
const ROUTER_PARAM_INVEST_TRANSACTIONS = "invest-transactions"
const ROUTER_PARAM_WITHDRAW_TRANSACTIONS = "withdraw-transactions"
const ROUTER_PARAM_SWITCH_TRANSACTIONS = "switch-transactions"
const ROUTER_PARAM_TRANSFER_TRANSACTIONS = "transfer-transactions"

const TRANSACTION_TYPE_TRANSFER_MONEY = "TRANSFER_MONEY"
const TRANSACTION_TYPE_SCHEDULE_WITHDRAW_MONEY = "SCHEDULE_WITHDRAW_MONEY_SCHEDULED"
const TRANSACTION_TYPE_SCHEDULE_WITHDRAW_MONEY_SWP = "SCHEDULE_WITHDRAW_MONEY_SWP"
const TRANSACTION_TYPE_WITHDRAW_MONEY = "WITHDRAW_MONEY"
const TRANSACTION_TYPE_INVEST_MONEY = "INVEST_MONEY"
const TRANSACTION_TYPE_SWITCH_MONEY = "SWITCH_MONEY"
const TRANSACTION_TYPE_DIVIDEND = "DIVIDEND"

const {Panel} = Collapse;
const AdminTransactionHistoryPage = () => {
    const routeParams: { type: "all-transactions" } = useParams();
    const history = useHistory();
    const [bottomReached, setBottomReached] = useState(false);
    const [nearBottom, setNearBottom] = useState(false)
    const [tableData, setTableData] = useState<TransactionHistoryWrapperDto[]>()
    const [isLoading, setLoading] = useState(false);
    const [showSecondCol, setShowSecondCol] = useState(false);
    const [rightSideSectionData, setRightSideSectionData] = useState<TransactionHistoryWrapperDto>({
        transactionTag: "",
        portfolioId: "",
        amount: 0,
        status: "",
        submittedDate: "",
        approvedDate: "",
        rejectReason: "",
        portfolioType: "",
        accountWiseFundDetailDtos: [],
    });
    const [transferMoneyRequestDocument, setTransferMoneyRequestDocument] = useState<UploadedDocumentDetailDto>();
    const [docURL, setDocURL] = useState('');
    const [previewOpen, setPreviewOpen] = useState(false);
    const [isCINRequired, setCINRequired] = useState(true);
    const [isIDRequired, setIDRequired] = useState(true);
    const [docType, setDocType] = useState<PREVIEW_DOC_TYPES>(PREVIEW_DOC_TYPES.IMAGE);
    const [documentName, setDocumentName] = useState<string>("");
    const [portfolioId, setPortfolioId] = useState<string | null>(null);
    const [customerCin, setCustomerCin] = useState<string>("");
    const [fundDropdownList, setFundDropdownList] = useState<DropdownListDto[]>([]);
    const [cinNumber, setCinNumber] = useState<string | null>(null);
    const location = useLocation();

    const [form] = Form.useForm();
    const [selectedRowKey, setSelectedRowKey] = useState<number | null>(null);
    const [userType, setUserType] = useState<number | null>(null);


    useEffect(() => {
        const handleScroll = () => {
            const scrollPosition = window.scrollY;
            const windowHeight = window.innerHeight;
            const documentHeight = document.documentElement.scrollHeight;
            const nearBottomThreshold = 30;
            if (documentHeight - scrollPosition - windowHeight <= nearBottomThreshold) {
                setNearBottom(true);
            } else {
                setNearBottom(false);
            }
            // Check if the user has scrolled to the bottom of the page
            if (scrollPosition + windowHeight >= documentHeight) {
                setBottomReached(true);
            } else {
                setBottomReached(false);
            }
        };

        fetchCustomerDetails(true)
        loadFundList()

        // Add scroll event listener when the component mounts
        window.addEventListener('scroll', handleScroll);

        // Clean up the event listener when the component unmounts
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };


    }, []);
    const loadFundList = () => {
        const inputDropdownParameterDto: InputDropdownParameterDto = {
            dropdownDataSourceId: COMMON_DROPDOWN.FUND_LIST,
            findTextValue: "",
            parameterList: [[PARAMETER_LIST.ACTIVE]]
        }
        customerService.getCommonDropdown(inputDropdownParameterDto).then(res => {
            if (res.data !== null) {
                setFundDropdownList(res.data.results.activeItemList)
            } else {
                message.error(MSG_FAILED_TO_FETCH_FUND_LIST_ERROR).then();
            }
        }, (reason) => {
            ErrorHandler.handleError(reason);

        })
    }
    const setDefaultDates = (status: string | null) => {
        let submittedDate = form.getFieldValue("submittedDate");


        if (undefined == submittedDate) {
            const toDate = dayjs();
            const fromDate = dayjs().subtract(3, "month");
            if ("PROCESSING" === status) {
                form.setFieldsValue({
                    submittedDate: [null, null],
                });
                return null;
            } else {
                form.setFieldsValue({
                    submittedDate: [fromDate, toDate],
                });
            }

            return form.getFieldValue("submittedDate");
        } else {
            return submittedDate;
        }
    };

    const handleDateChange = (dates: any) => {
        if (dates) {
            const [fromDate, toDate] = dates;

            if (fromDate && !toDate) {
                form.setFieldsValue({
                    submittedDate: [fromDate, fromDate.add(3, "month")],
                });
            }

            if (toDate && !fromDate) {
                form.setFieldsValue({
                    submittedDate: [toDate.subtract(3, "month"), toDate],
                });
            }
        }
    };
    const fetchCustomerDetails = (initial: boolean) => {

        let filterCrier = {
            status: null,
            amount: null,
            portfolioId: null,
            submittedDate: null,
            cin: null,
            transactionType: null,
            fundId: null
        }
        form.setFieldsValue({transactionType: getDefaultValueForSearch()})
        onSearch(filterCrier, initial)
    }

    const closeRightSideSection = () => {
        setSelectedRowKey(null)
        setShowSecondCol(false);
        setTimeout(() => {
            document.querySelector('.collapse-row-container')?.classList.toggle('show-second-div', false);
        }, 10);
    };
    const passDataToRightSideSection = (recordData: TransactionHistoryWrapperDto, index: number) => {
        setSelectedRowKey(index)
        setTransferMoneyRequestDocument(null)
        setRightSideSectionData(recordData)
        setShowSecondCol(true);
        if (recordData.accountWiseFundDetailDtos[0].transactionDocumentId != null) {
            loadDocument(recordData.accountWiseFundDetailDtos[0].transactionDocumentId, recordData.accountWiseFundDetailDtos[0].jobNumber,
                getDocCodeByTransactionTag(recordData.transactionTag))
        }

        setTimeout(() => {
            document.querySelector('.collapse-row-container')?.classList.toggle('show-second-div', true);
        }, 10);
    };

    const getDocCodeByTransactionTag = (tag: string) => {
        return tag === 'INVEST_MONEY' ? DOC_CODE_INVEST_TRANSACTION_DOCUMENT :
            tag === TRANSACTION_TYPE_WITHDRAW_MONEY ? DOC_CODE_WITHDRAW_TRANSACTION_DOCUMENT :
                tag === TRANSACTION_TYPE_SCHEDULE_WITHDRAW_MONEY ? DOC_CODE_WITHDRAW_TRANSACTION_DOCUMENT :
                    tag === TRANSACTION_TYPE_SCHEDULE_WITHDRAW_MONEY_SWP ? DOC_CODE_WITHDRAW_TRANSACTION_DOCUMENT :
                        tag === TRANSACTION_TYPE_TRANSFER_MONEY ? DOC_CODE_TRANSFER_TRANSACTION_DOCUMENT : DOC_CODE_SWITCH_TRANSACTION_DOCUMENT
    }
    const columns = [
        {
            title: 'Transaction',
            dataIndex: 'transactionTag',
            key: 'transactionTag',
            sorter: (a: TransactionHistoryWrapperDto, b: TransactionHistoryWrapperDto) => {
                const dateA = a.submittedDate ? dayjs(a.submittedDate) : dayjs(0);
                const dateB = b.submittedDate ? dayjs(b.submittedDate) : dayjs(0);
                return dateA - dateB;
            },
            render: (text: any, record: {
                status: string;
                transactionTag: string;
                submittedDate: string
            }) => <>
                <div className="transaction_type_div">
                    {/*<div className="transaction_type_icon">*/}
                    <div className={
                        record.transactionTag === TRANSACTION_TYPE_INVEST_MONEY ? 'invest-transaction' :
                            record.transactionTag === TRANSACTION_TYPE_WITHDRAW_MONEY ? 'withdraw-transaction' :
                                record.transactionTag === TRANSACTION_TYPE_SCHEDULE_WITHDRAW_MONEY ? 'withdraw-transaction' :
                                    record.transactionTag === TRANSACTION_TYPE_SCHEDULE_WITHDRAW_MONEY_SWP ? 'withdraw-transaction' :
                                        record.transactionTag === TRANSACTION_TYPE_DIVIDEND ? 'dividend-transaction' :
                                            record.transactionTag === TRANSACTION_TYPE_TRANSFER_MONEY ? 'transfer-transaction' : 'switch-transaction'
                    }>
                        <div className={
                            record.status === 'PROCESSING' ? 'processing-transaction' :
                                record.status === 'SUBMITTED' ? 'submitted-transaction' :
                                    record.status === 'COMPLETED' ? 'completed-transaction' :
                                        record.status === 'DIVIDEND' ? 'dividend-transaction' :
                                            record.status === 'CANCELLED' ? 'cancelled-transaction' : 'rejected-transaction'
                        }>
                            <div className="transfer-icon"></div>

                        </div>
                    </div>
                    <div className="transaction_text">
                            <span className="transaction_type">
                                {
                                    record.transactionTag === 'INVEST_MONEY' ? 'Invest' :
                                        record.transactionTag === TRANSACTION_TYPE_TRANSFER_MONEY ? 'Transfer' :
                                            record.transactionTag === TRANSACTION_TYPE_SCHEDULE_WITHDRAW_MONEY ? 'Scheduled Withdraw' :
                                                record.transactionTag === TRANSACTION_TYPE_SCHEDULE_WITHDRAW_MONEY_SWP ? 'Scheduled Withdraw SWP' :
                                                    record.transactionTag === TRANSACTION_TYPE_DIVIDEND ? 'Dividend' :
                                                        record.transactionTag === TRANSACTION_TYPE_WITHDRAW_MONEY ? 'Withdraw' : 'Switch'
                                }
                            </span>
                        <span className="transaction_date">on <span
                            className={'bold-date-time'}>
                            {null != text ? dayjs(record.submittedDate).format(YYYY_MM_DD) : NOT_AVAILABLE}
                        </span>
                        </span>
                    </div>
                </div>
            </>,
        },
        {
            title: 'Portfolio ID',
            dataIndex: 'portfolioId',
            key: 'portfolioId',
            sorter: (a: any, b: any) => {
                a = a.portfolioId == null ? '' : a.portfolioId
                b = b.portfolioId == null ? '' : b.portfolioId
                return a.localeCompare(b);
            },
            render: (text: any, record: {
                portfolioId: string;
                portfolioType: string;

            }) => <>
                <div className="portfolio-details">
                    <div className="portfolio-id-data">
                        <span>{CommonFunction.validateText(record.portfolioId)}</span>
                    </div>
                    <div className="portfolio-type-tag">
                        {/*<Tag color='purple'>Joint Account</Tag>*/}
                        <Tag color='processing'>{CommonFunction.validateText(record.portfolioType)}</Tag>
                    </div>
                </div>
            </>
        },
        {
            title: 'Units',
            dataIndex: 'quantities',
            key: 'quantities',
            sorter: (a: any, b: any) => (a.quantities - b.quantities),
            render: (text: any, record: any) =>
                <span>
                    {null != text ?
                        <NumericFormat value={text} displayType={'text'} decimalScale={2} fixedDecimalScale={true}
                                       thousandSeparator={true}/> : NOT_AVAILABLE}
                </span>,
        },
        {
            title: 'Price',
            dataIndex: 'unit_price',
            key: 'unit_price',
            align: 'right',
            sorter: (a: any, b: any) => (a.unit_price - b.unit_price),
            render: (text: any, record: any) =>
                <span>
                    {null != text ?
                        <NumericFormat value={text} displayType={'text'} decimalScale={4} fixedDecimalScale={true}
                                       thousandSeparator={true}/> : NOT_AVAILABLE}
                </span>,
        },
        {
            title: 'Amount',
            dataIndex: 'amount',
            key: 'amount',
            align: 'right',
            sorter: (a: any, b: any) => (a.amount - b.amount),

            render: (text: number) => (
                <>
                    {null != text ?
                        <NumericFormat value={text} displayType={'text'} decimalScale={2} fixedDecimalScale={true}
                                       thousandSeparator={true}/> : NOT_AVAILABLE}

                </>
            ),
        },
        {
            title: 'Status',
            key: 'status',
            dataIndex: 'status',
            align: 'center',
            sorter: (a: any, b: any) => {
                a = a.status == null ? '' : a.status
                b = b.status == null ? '' : b.status
                return a.localeCompare(b);
            },
            render: (text: any, record: { status: any; }) => (
                <>
                    {getStatusTag(record.status)}

                </>
            ),
        },
        {
            title: 'More Info',
            key: 'action',
            align: 'center',
            render: (text: any, record: any, index: number) => (

                // <Tooltip title="More Info" placement="right" color={'#108ee9'} key={'#108ee9'}>
                <Button onClick={() => passDataToRightSideSection(record, index)} icon={<EllipsisOutlined/>}
                        size={'small'}></Button>
                // </Tooltip>
            ),
        },
    ];

    const getStatusTag = (status: string) => {
        return <Tag
            className={status === "PROCESSING" ? 'tag-processing' : status === "COMPLETED" ?
                'tag-success' : status === "SUBMITTED" ? 'tag-submitted' : status === "CANCELLED" ? 'tag-cancelled' : 'tag-reject'}>{status}</Tag>

    }
    const getTransactionStatusIconClass = (status: string) => {
        return status === "PROCESSING" ? 'processing-transaction' : status === "COMPLETED" ? 'completed-transaction' : status === "SUBMITTED" ? 'submitted-transaction' : status === "CANCELLED" ? 'cancelled-transaction' : 'rejected-transaction'
    }

    const onSearch = (filterCriterias: {
        transactionType: null | string;
        amount: number | null;
        portfolioId: string | null;
        status: string | null,
        submittedDate: any | null,
        cin: string | null,
        identificationValue: string | null,
        fundId: number | null
    }, initial: boolean) => {
        setLoading(true)

        if (!initial) {
            // if(checkNullOrEmpty(filterCriterias.cin) && checkNullOrEmpty(filterCriterias.portfolioId)){
            //     filterCriterias.submittedDate = setDefaultDates()
            // }
            filterCriterias.submittedDate = setDefaultDates(filterCriterias.status)
        } else {
            setLoading(false)
            setCINRequired(true)
            return Object.values(filterCriterias).every(isEmptyOrNull) ? false : true;

        }

        let amountWithoutCommaSeperators = filterCriterias.amount
        if (filterCriterias.amount) {
            amountWithoutCommaSeperators = toNumber(CommonFunction.removeThousandSeparators(filterCriterias.amount.toString()))
        }

        let submittedDateFrom = null
        let submittedDateTo = null

        if (filterCriterias.submittedDate) {
            submittedDateFrom = checkNullOrEmpty(filterCriterias.submittedDate[0]) ? null : filterCriterias.submittedDate[0].format(YYYY_MM_DD)
            submittedDateTo = checkNullOrEmpty(filterCriterias.submittedDate[1]) ? null : filterCriterias.submittedDate[1].format(YYYY_MM_DD)
        }

        if (null != portfolioId) {
            filterCriterias.portfolioId = portfolioId
        }
        const filter = {
            transactionType: filterCriterias.transactionType ?? null,
            cin: filterValueValidate(filterCriterias.cin),
            identificationValue: filterValueValidate(filterCriterias.identificationValue),
            amount: filterValueValidate(amountWithoutCommaSeperators),
            portfolioId: filterValueValidate(filterCriterias.portfolioId),
            statuses: filterCriterias.status ?? null,
            submittedDateFrom: submittedDateFrom,
            submittedDateTo: submittedDateTo,
            fundId: filterCriterias.fundId
        } as TransactionHistoryFilterDto
        transactionFetchService.getTransactionHistoryListForAdmin(filter).then(
            (res: CommonAxiosSuccessResponseDto<TransactionHistoryDto>) => {
                setTableData(res.data.results);
                setLoading(false)
            }).catch((res) => {
            setLoading(false)
            ErrorHandler.handleError(res)
        })
    }
    const filterValueValidate = (value: any) => {
        return value === "" ? null : value ?? null
    }

    const isEmptyOrNull = (value: any) => {

        return value === null || value === "";
    };

    const checkNullOrEmpty = (value: string | null) => {
        if (null != value && "" != value) {
            return false;
        }
        return true;
    }

    const loadDocument = (documentDetailId: number, jobNumber: number, type: string) => {
        documentService.getUploadDocumentListByTypeAndUploadedDocId(jobNumber, documentDetailId, [type]).then(res => {
            if (res.data.status == 'SUCCESS') {
                setTransferMoneyRequestDocument(res.data.results[0].uploadDocumentDetailDto);
            }
        }, (reason) => {
            ErrorHandler.handleError(reason);
        });
    }

    const getDefaultValueForSearch = () => {
        return routeParams.type === ROUTER_PARAM_ALL_TRANSACTIONS ? null :
            routeParams.type === ROUTER_PARAM_INVEST_TRANSACTIONS ? TRANSACTION_TYPE_INVEST_MONEY :
                routeParams.type === ROUTER_PARAM_TRANSFER_TRANSACTIONS ? TRANSACTION_TYPE_TRANSFER_MONEY :
                    routeParams.type === ROUTER_PARAM_WITHDRAW_TRANSACTIONS ? TRANSACTION_TYPE_WITHDRAW_MONEY :
                        TRANSACTION_TYPE_SWITCH_MONEY;
    }
    const getTransactionTypeDisplayName = (type: string) => {
        return type === TRANSACTION_TYPE_INVEST_MONEY ? 'Invest' :
            type === TRANSACTION_TYPE_TRANSFER_MONEY ? 'Transfer' :
                type === TRANSACTION_TYPE_SCHEDULE_WITHDRAW_MONEY ? 'Scheduled Withdraw' :
                    type === TRANSACTION_TYPE_SCHEDULE_WITHDRAW_MONEY_SWP ? 'Scheduled Withdraw SWP' :
                        type === TRANSACTION_TYPE_DIVIDEND ? 'Dividend' :
                            type === TRANSACTION_TYPE_SWITCH_MONEY ? 'Switch' : 'Withdraw'
    }
    // const handleBlur = (event: React.FocusEvent<HTMLInputElement>) => {
    //     const name = 'amount';
    //     const value = event.target.value;
    //     toFixedMethod(name, value);
    // };

    const handleFocus = (event: React.FocusEvent<HTMLInputElement>) => {
        const value = event.target.value;
        if (NEGATIVE_AMOUNT_VALIDATION.test(value)) {
            const name = 'amount';
            let amount = CommonFunction.removeThousandSeparators(value);
            amount = amount.replace('.00', "")
            form.setFieldsValue({[name]: amount});
            form.validateFields([name]);
        }
    };
    const handleBlur = (event: React.FocusEvent<HTMLInputElement>) => {
        const value = event.target.value;
        const name = 'amount';
        if (NEGATIVE_AMOUNT_VALIDATION.test(value)) {
            formatAndSetAmount(value, name)
        } else if (DIGITS_AND_DOT_VALIDATION.test(value)) {
            formatAndSetAmount(value, name)

        }
    };

    const formatAndSetAmount = (value: string, name: string) => {
        CommonFunction.toFixedMethod(name, value, form);
        form.validateFields([name]);
    }


    const resetFilters = () => {
        form.resetFields()
        let filterCriteria = {
            status: null,
            amount: null,
            cin: null,
            identificationValue: null,
            portfolioId: null,
            submittedDate: null,
            transactionType: null,
            fundId: null
        }
        form.setFieldsValue({transactionType: getDefaultValueForSearch()})
        onSearch(filterCriteria, true)
        setTableData([])
        setCINRequired(true)
        setIDRequired(true)
    }
    const getCardIconByTransaction = (status: string) => {
        return status === TRANSACTION_TYPE_INVEST_MONEY ? 'invest-transaction' :
            status === TRANSACTION_TYPE_TRANSFER_MONEY ? 'transfer-transaction' :
                status === TRANSACTION_TYPE_SCHEDULE_WITHDRAW_MONEY ? 'withdraw-transaction' :
                    status === TRANSACTION_TYPE_SCHEDULE_WITHDRAW_MONEY_SWP ? 'withdraw-transaction' :
                        status === TRANSACTION_TYPE_DIVIDEND ? 'dividend-transaction' :
                            status === TRANSACTION_TYPE_SWITCH_MONEY ? 'switch-transaction' : 'withdraw-transaction'
    }
    const getTimeLine = () => {
        return <>
            <Col span={24}>
                <Divider style={{marginTop: 8, marginBottom: 12}}></Divider>
                <h4 className={'transaction_details_header'}>Timeline</h4>
            </Col>
            <Col span={24} className={'time-line-col'}>
                <Timeline
                    items={getTimelineItems(rightSideSectionData)}
                />
            </Col>
        </>
    }

    const getTimelineItems = (rightSideSectionData: TransactionHistoryWrapperDto) => {

        const items = [
            {
                dot: <SendOutlined style={{fontSize: 20}}/>,
                color: '#1976D2',
                children: (
                    <>
                        <p className={'time-line-label'}>Request Submitted on</p>
                        <p className={'time-line-date-time'}>{dayjs(rightSideSectionData.submittedDate).format('YYYY-MM-DD')}</p>
                    </>
                ),
            },
        ];

        if (rightSideSectionData.status !== "PROCESSING" && rightSideSectionData.status !== "SUBMITTED") {
            items.unshift({
                dot: rightSideSectionData.status === "COMPLETED" ?
                    <CheckCircleOutlined style={{fontSize: 20}}/> : rightSideSectionData.status === "CANCELLED" ?
                        <StopOutlined style={{fontSize: 20}}/> : <CloseCircleOutlined style={{fontSize: 20}}/>,
                color: rightSideSectionData.status === "COMPLETED" ? '#14A44DFF' : rightSideSectionData.status === "CANCELLED" ? '#934b00' : '#C72C41FF',
                // className: rightSideSectionData.status === "PENDING" ? 'displayNone' : 'displayFlex',
                children: (
                    <>
                        <p className={'time-line-label'}>
                            {rightSideSectionData.status === "COMPLETED" ? <>Request Completed
                                on</> : rightSideSectionData.status === "CANCELLED" ? <>Request Cancelled
                                on</> : <>Request
                                Rejected
                                on</>}
                        </p>
                        <p className={'time-line-date-time'}>{dayjs(rightSideSectionData.approvedDate).format('YYYY-MM-DD HH:mm')}</p>
                    </>
                ),
            });
        }
        return items;
    }
    const getUploadedDocument = () => {
        if (transferMoneyRequestDocument) {
            return <Col span={24}>
                <Statistic className={'empty-statistic'}
                           title="Fund Transfer Receipt"
                           value={''}/>
                <div className='utility_bill img-nic'>
                    <div className='utulity_bill_icon_div'>
                        <div className="img_div">
                            <img src={transferMoneyRequestDocument?.thumbB64}
                                 alt=""/>
                        </div>
                        <div className='name_div'>
                            <h5>{transferMoneyRequestDocument?.documentTypeName}</h5>
                        </div>
                    </div>
                    <Button className='doc-view-btn' disabled={false}
                            onClick={() => openModal(transferMoneyRequestDocument)}
                    ><EyeOutlined/></Button>
                </div>
            </Col>
        } else {
            return <></>
        }
    }

    const getOtherDetails = (data: TransactionHistoryWrapperDto) => {

        let accountWiseFundDetailDto = data.accountWiseFundDetailDtos[0];

        return <>
            <Col span={24}>
                <Divider style={{marginTop: 8, marginBottom: 12}}></Divider>
                <h4 className={'transaction_details_header'}>Other Details</h4>
            </Col>
            <Col span={12}>
                <Statistic title="Created By"
                           value={accountWiseFundDetailDto.createdBy ?? 'N/A'}/>
            </Col>
            <Col span={12}>
                <Statistic title="Created Datetime"
                           value={(undefined == accountWiseFundDetailDto.createdDate || null == accountWiseFundDetailDto.createdDate) ? "N/A" : dayjs(accountWiseFundDetailDto.createdDate).format(YYYY_MM_DD_HH_MM)}/>
            </Col>
            {
                data.status === "COMPLETED"
                    ? renderStatusDetails("Authorized", accountWiseFundDetailDto)
                    : data.status === "CANCELLED"
                        ? renderStatusDetails("Cancelled", accountWiseFundDetailDto)
                        : data.status === "REJECTED"
                            ? renderStatusDetails("Rejected", accountWiseFundDetailDto)
                            : null
            }
        </>
    }

    const renderStatusDetails = (statusTitle: string , accountWiseFundDetailDto: AccountWiseFundDetailDto) => (
        <>
            <Col span={12}>
                <Statistic title={`${statusTitle} By`} value={accountWiseFundDetailDto.authUser ?? 'N/A'} />
            </Col>
            <Col span={12}>
                <Statistic
                    title={`${statusTitle} Datetime`}
                    value={
                        accountWiseFundDetailDto.authDateTime
                            ? dayjs(accountWiseFundDetailDto.authDateTime).format(YYYY_MM_DD_HH_MM)
                            : 'N/A'
                    }
                />
            </Col>
        </>
    );

    const openModal = (document: UploadedDocumentDetailDto | undefined) => {
        if (document) {
            documentService.viewOriginalDocument(document.uploadDocumentDetailId.toString()).then(res => {
                if (res.data !== null) {
                    setPreviewOpen(true)
                    setDocURL(res.data.results)
                    setDocType(Validation.checkDocumentContentType(res.data.results))
                    setDocumentName(document.originalDocumentName)
                } else {
                    message.error(MSG_FAILED_TO_FETCH_DOCUMENTS_ERROR).then();
                }
            }, (reason) => {
                ErrorHandler.handleError(reason);
            })
            return true;
        }

    };
    const toFixedAmount = (value: number | undefined): any => {
        if (undefined != value) {
            let val = value.toString();
            if (val.indexOf(".") != -1) {
                val = val.slice(0, (val.indexOf(".")) + 3);
            }
            val = (+val).toFixed(2);
            return val.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        }
        return "0.00";
    }
    const download = (val: string, docName: string) => {
        let a = document.createElement('a');
        a.href = val;
        a.download = docName;
        a.click();
    }
    const handlePreviewCancel = () => {
        setPreviewOpen(false);
    };
    //OK
    const getTransferRightSideDocData = () => {
        let accountWiseFundDetailDtoFrom = rightSideSectionData.accountWiseFundDetailDtos[0];
        return <Row gutter={[16, 12]} className={'transaction_details'}>

            <Col span={24}>
                <h4 className={'transaction_details_header'}>Transaction
                    Details</h4>
            </Col>

            <Col span={24}>
                <Card size={'small'} title={'Transfer From'}>
                    <Row gutter={[16, 12]}>
                        <Col span={12}>
                            <Statistic title="Portfolio ID"
                                       value={accountWiseFundDetailDtoFrom.portfolioNumber}
                                       formatter={(value: string) => null == value ? 'N/A' : value.replace(',', '')}
                            />
                        </Col>
                        <Col span={12}>
                            <Statistic title="Fund"
                                       value={CommonFunction.validateText(accountWiseFundDetailDtoFrom.fundName)}/>
                        </Col>
                        <Col span={12}>
                            <Statistic title="Amount"
                                       value={toFixedAmount(accountWiseFundDetailDtoFrom.fundAmount)}/>
                        </Col>
                        <Col span={12}>
                            <Statistic title="Status"
                                       formatter={() => {
                                           return NOT_AVAILABLE != CommonFunction.validateText(accountWiseFundDetailDtoFrom.transactionVerificationStatus) ? getStatusTag(accountWiseFundDetailDtoFrom.transactionVerificationStatus as string) : NOT_AVAILABLE
                                       }}/>
                        </Col>
                    </Row>
                </Card>
            </Col>
            {
                rightSideSectionData.accountWiseFundDetailDtos && rightSideSectionData.accountWiseFundDetailDtos.length > 1 ?
                    <Col span={24}>
                        <Card size={'small'} title={'Transfer To'}>
                            <Row gutter={[16, 12]}>
                                <Col span={12}>
                                    <Statistic title="Account Type"
                                               value={CommonFunction.validateText(rightSideSectionData.accountWiseFundDetailDtos[1].accountType)}/>
                                </Col>
                                <Col span={12}>
                                    <Statistic title="Portfolio ID"
                                               value={CommonFunction.validateText(rightSideSectionData.accountWiseFundDetailDtos[1].portfolioNumber)}
                                               formatter={(value: string) => value.replace(',', '')}
                                    />

                                </Col>

                                {
                                    rightSideSectionData.accountWiseFundDetailDtos[1].accountType === "OTHER" ?
                                        <Col span={12}>
                                            <Statistic title="Name"
                                                       value={CommonFunction.validateText(rightSideSectionData.accountWiseFundDetailDtos[1].customerName)}/>
                                        </Col> : ''

                                }
                                <Col span={12}>
                                    <Statistic title="Status"
                                               formatter={() => {
                                                   return NOT_AVAILABLE != CommonFunction.validateText(rightSideSectionData.accountWiseFundDetailDtos[1].transactionVerificationStatus) ? getStatusTag(rightSideSectionData.accountWiseFundDetailDtos[1].transactionVerificationStatus as string) : NOT_AVAILABLE
                                               }}/>
                                </Col>

                                {getUploadedDocument()}
                            </Row>
                        </Card>
                    </Col> : ''
            }
            {checkTimeLineAvailable() ? getTimeLine() : <></>}
            {getOtherDetails(rightSideSectionData)}

        </Row>
    }

    const checkTimeLineAvailable = () => {
        if (null != rightSideSectionData.submittedDate || null != rightSideSectionData.approvedDate) {
            return true;
        }
        return false;
    }
    //OK
    const getSwitchRightSideDocData = () => {
        const accountWiseFundDetailDtoFrom = rightSideSectionData.accountWiseFundDetailDtos[0];
        return <Row gutter={[16, 12]} className={'transaction_details'}>

            <Col span={24}>
                <h4 className={'transaction_details_header'}>Transaction
                    Details</h4>
            </Col>

            <Col span={24}>
                <Card size={'small'} title={'Switch From'}>
                    <Row gutter={[16, 12]}>
                        <Col span={12}>
                            <Statistic title="Portfolio ID"
                                       value={rightSideSectionData.portfolioId}
                                       formatter={(value: string) => null == value ? 'N/A' : value.replace(',', '')}
                            />
                        </Col>
                        <Col span={12}>
                            <Statistic title="Fund"
                                       value={CommonFunction.validateText(accountWiseFundDetailDtoFrom.fundName)}/>
                        </Col>
                        <Col span={12}>
                            <Statistic title="Amount"
                                       value={toFixedAmount(accountWiseFundDetailDtoFrom.fundAmount)}/>
                        </Col>
                        <Col span={12}>
                            <Statistic title="Status"
                                       formatter={() => {
                                           return NOT_AVAILABLE != CommonFunction.validateText(accountWiseFundDetailDtoFrom.transactionVerificationStatus) ? getStatusTag(accountWiseFundDetailDtoFrom.transactionVerificationStatus as string) : NOT_AVAILABLE
                                       }}/>
                        </Col>
                    </Row>
                </Card>
            </Col>
            {
                rightSideSectionData.accountWiseFundDetailDtos && rightSideSectionData.accountWiseFundDetailDtos.length > 1 ?
                    <Col span={24}>
                        <Card size={'small'} title={'Switch To'}>
                            <Row gutter={[16, 12]}>
                                <Col span={12}>
                                    <Statistic title="Fund"
                                               value={CommonFunction.validateText(rightSideSectionData.accountWiseFundDetailDtos[1].fundName)}/>
                                </Col>
                                <Col span={12}>
                                    <Statistic title="Status"
                                               formatter={() => {
                                                   return NOT_AVAILABLE != CommonFunction.validateText(rightSideSectionData.accountWiseFundDetailDtos[1].transactionVerificationStatus) ? getStatusTag(rightSideSectionData.accountWiseFundDetailDtos[1].transactionVerificationStatus as string) : NOT_AVAILABLE
                                               }}/>
                                </Col>
                                {getUploadedDocument()}
                            </Row>
                        </Card>
                    </Col> : ''
            }

            {checkTimeLineAvailable() ? getTimeLine() : <></>}
            {getOtherDetails(rightSideSectionData)}

        </Row>
    }

    const getWithdrawRightSideDocData = (withdrawType: string) => {
        const accountWiseFundDetailDto = rightSideSectionData.accountWiseFundDetailDtos[0];

        let bankDetail = {
            bankName: "",
            branch: "",
            accountNo: ""
        }
        if (accountWiseFundDetailDto.thirdPartyBankDetailsDto !== null) {
            let bankData = accountWiseFundDetailDto.thirdPartyBankDetailsDto
            bankDetail.bankName = bankData.bankName
            bankDetail.branch = bankData.branchName
            bankDetail.accountNo = bankData.accountNo
        } else if (accountWiseFundDetailDto.bankDetailDto !== null) {
            let bankData = accountWiseFundDetailDto.bankDetailDto
            bankDetail.bankName = bankData.bankName ?? ""
            bankDetail.branch = bankData.branchName ?? ""
            bankDetail.accountNo = bankData.accountNo
        }
        return <Row gutter={[16, 12]} className={'transaction_details'}>

            <Col span={24}>
                <h4 className={'transaction_details_header'}>Transaction
                    Details</h4>
            </Col>
            <Col span={12}>
                <Statistic title="Withdraw Type" value={withdrawType}/>
            </Col>
            <Col span={12}>
                <Statistic title="Portfolio ID"
                           value={rightSideSectionData.portfolioId}
                           formatter={(value: string) => null == value ? 'N/A' : value.replace(',', '')}
                />
            </Col>
            <Col span={12}>
                <Statistic title="Fund"
                           value={CommonFunction.validateText(accountWiseFundDetailDto.fundName)}/>
            </Col>
            <Col span={12}>
                <Statistic title="Amount"
                           value={toFixedAmount(accountWiseFundDetailDto.fundAmount)}/>
            </Col>
            <Col span={12}>
                <Statistic title="Bank" value={CommonFunction.validateText(bankDetail.bankName)}/>
            </Col>
            <Col span={12}>
                <Statistic title="Bank Branch" value={CommonFunction.validateText(bankDetail.branch)}/>
            </Col>
            <Col span={12}>
                <Statistic title="Account Number" value={bankDetail.accountNo}
                           formatter={(value: string) => (undefined == value || null == value || "" == value) ? 'N/A' : value.replace(',', '')}
                />
            </Col>
            {
                withdrawType !== "Online" ?
                    <>
                        <Col span={12}>
                            <Statistic title="Withdrawal Frequency"
                                       value={accountWiseFundDetailDto.withdrawalFrequencyTag !== null ?
                                           accountWiseFundDetailDto.withdrawalFrequencyTag === "ONE_TIME" ? "One Time" : "Monthly" : "N/A"}/>
                        </Col>

                    </> : ''
            }
            <Col span={12}>
                <Statistic title="Withdrawal Date"
                           value={(undefined == accountWiseFundDetailDto.transactionScheduledDateTime || null == accountWiseFundDetailDto.transactionScheduledDateTime) ? "N/A" : dayjs(accountWiseFundDetailDto.transactionScheduledDateTime).format(YYYY_MM_DD)}/>
            </Col>
            <Col span={12}>
                <Statistic title="Transaction Reference Number"
                           value={accountWiseFundDetailDto.transactionRefNo ?? 'N/A'}/>
            </Col>
            {getUploadedDocument()}


            {checkTimeLineAvailable() ? getTimeLine() : <></>}
            {getOtherDetails(rightSideSectionData)}

        </Row>
    }
    //OK
    const investRightSideDocData = () => {
        let accountWiseFundDetailDto = rightSideSectionData.accountWiseFundDetailDtos[0];
        return <Row gutter={[16, 12]} className={'transaction_details'}>

            <Col span={24}>
                <h4 className={'transaction_details_header'}>Transaction Details</h4>
            </Col>
            <Col span={12}>
                <Statistic title="Portfolio ID"
                           value={rightSideSectionData.portfolioId}
                           formatter={(value: string) => null == value ? 'N/A' : value.replace(',', '')}
                />
            </Col>
            <Col span={12}>
                <Statistic title="Fund"
                           value={CommonFunction.validateText(accountWiseFundDetailDto.fundName)}/>
            </Col>
            <Col span={12}>
                <Statistic title="Amount"
                           value={toFixedAmount(accountWiseFundDetailDto.fundAmount)}/>
            </Col>
            <Col span={12}>
                <Statistic title="Collection Account"
                           value={accountWiseFundDetailDto.collectionBank}
                           formatter={(value: string) => null == value ? 'N/A' : value.replace(',', '')}
                />
            </Col>
            <Col span={12}>
                <Statistic title="Transaction Reference Number"
                           value={accountWiseFundDetailDto.transactionRefNo}
                           formatter={(value: string) => null == value ? 'N/A' : value.replace(',', '')}
                />
            </Col>

            {getUploadedDocument()}

            {checkTimeLineAvailable() ? getTimeLine() : <></>}
            {getOtherDetails(rightSideSectionData)}

        </Row>
    }

    const dividendRightSideDocData = () => {
        let accountWiseFundDetailDto = rightSideSectionData.accountWiseFundDetailDtos[0];
        return <Row gutter={[16, 12]} className={'transaction_details'}>

            <Col span={24}>
                <h4 className={'transaction_details_header'}>Transaction Details</h4>
            </Col>
            <Col span={12}>
                <Statistic title="Portfolio ID"
                           value={rightSideSectionData.portfolioId}
                           formatter={(value: string) => null == value ? 'N/A' : value.replace(',', '')}
                />
            </Col>
            <Col span={12}>
                <Statistic title="Fund"
                           value={CommonFunction.validateText(accountWiseFundDetailDto.fundName)}/>
            </Col>
            <Col span={12}>
                <Statistic title="Units"
                           value={accountWiseFundDetailDto.quantities}
                           formatter={(value: number) => null == value ? 'N/A' : value.toFixed(2)}
                />
            </Col>
            <Col span={12}>
                <Statistic title="Price"
                           value={accountWiseFundDetailDto.unit_price}
                           formatter={(value: number) => null == value ? 'N/A' : value.toFixed(4)}
                />
            </Col>
            <Col span={12}>
                <Statistic title="Amount"
                           value={toFixedAmount(accountWiseFundDetailDto.fundAmount)}/>
            </Col>

            {getOtherDetails(rightSideSectionData)}

        </Row>
    }

    const goBack = () => {
        if (cinNumber) {
            if (1 == userType) {
                history.push('/workflow/admin/relationship-manager-dashboard')
            } else if (0 == userType) {
                history.push({
                    pathname: '/workflow/customer/dashboard',
                    state: {portfolioId},
                });
            } else {
                history.push('/workflow/admin/relationship-manager-dashboard')
            }
        } else {
            history.push({
                pathname: '/workflow/customer/dashboard',
                state: {portfolioId},
            });
        }
    }

    const onChangeStatus = (status: string | null) => {
        if ("PROCESSING" === status) {
            setCINRequired(false)
            setIDRequired(false)
        } else {

            let identificationValue = form.getFieldValue("identificationValue");
            let cin = form.getFieldValue("cin");

            if (checkNullOrEmpty(identificationValue)){
                setCINRequired(true)
                setIDRequired(false)
            }else if(checkNullOrEmpty(cin)) {
                setIDRequired(true)
                setCINRequired(false)
            }
        }
    }

    const onCinChange = (e: Event) => {
        if ("" == e.target?.value){
            let status = form.getFieldValue("status");
            if ("PROCESSING" !== status) {
                setIDRequired(true)
            }else {
                setIDRequired(false)
            }
        }else {
            setIDRequired(false)
            form.validateFields(['identificationValue'])

        }
    }

    const onIDChange = (e: Event) => {
        if ("" == e.target?.value){
            let status = form.getFieldValue("status");
            if ("PROCESSING" !== status) {
                setCINRequired(true)
            }else {
                setIDRequired(false)
            }
        }else {
            setCINRequired(false)
            form.validateFields(['cin'])
        }

    }

    return < >
        <Row gutter={[16, 16]}>
            <Col xs={24} sm={24} md={24} lg={24} xl={24} className='page-header-main-title-col'>
                <h2 className='page-header-main-title'
                    style={{display: "flex", flexDirection: "row", alignItems: "center"}}>
                    <div className='header_icon header-icon-center'>
                        <img style={{height: 24, width: 24}} src={trans_img} alt=""/>
                    </div>
                    Transaction History
                </h2>
            </Col>
        </Row>
        <div className={'collapse-row-container'} style={{marginTop: 8}}>
            {null != cinNumber || null != portfolioId ?
                <FloatButton tooltip={<div>Go Back</div>}
                             onClick={goBack}
                             icon={<FontAwesomeIcon icon={faCircleLeft} style={{color: "#008d86",}}/>}
                             shape="square"
                /> : <></>}
            <div className={`firstDiv${showSecondCol ? ' shrink' : ''}`}>
                <Row gutter={[16, 16]}>
                    <Col span={24}>
                        <Collapse>
                            <Panel header="Filter Transaction History" key="1">
                                <Form layout={"vertical"} onFinish={(val) => onSearch(val, false)} form={form}
                                      onReset={resetFilters}>
                                    <Row gutter={[16, 0]}>
                                        <Col xxl={6} xl={showSecondCol ? 12 : 6} lg={12} md={24}>
                                            <Form.Item label="Transaction Type" name="transactionType"
                                                       initialValue={getDefaultValueForSearch}>
                                                <Select style={{width: '100%'}}
                                                        defaultValue={getDefaultValueForSearch}
                                                        options={[
                                                            {
                                                                value: null, label: 'All',
                                                                disabled: routeParams.type !== ROUTER_PARAM_ALL_TRANSACTIONS
                                                            },

                                                            {
                                                                value: TRANSACTION_TYPE_INVEST_MONEY,
                                                                label: 'Invest',
                                                                disabled: routeParams.type !== ROUTER_PARAM_INVEST_TRANSACTIONS &&
                                                                    routeParams.type !== ROUTER_PARAM_ALL_TRANSACTIONS
                                                            },
                                                            {
                                                                value: TRANSACTION_TYPE_WITHDRAW_MONEY,
                                                                label: 'Withdraw',
                                                                disabled: routeParams.type !== ROUTER_PARAM_WITHDRAW_TRANSACTIONS &&
                                                                    routeParams.type !== ROUTER_PARAM_ALL_TRANSACTIONS
                                                            },
                                                            {
                                                                value: TRANSACTION_TYPE_SCHEDULE_WITHDRAW_MONEY,
                                                                label: 'Scheduled Withdraw',
                                                                disabled: routeParams.type !== ROUTER_PARAM_WITHDRAW_TRANSACTIONS &&
                                                                    routeParams.type !== ROUTER_PARAM_ALL_TRANSACTIONS
                                                            },
                                                            {
                                                                value: TRANSACTION_TYPE_SCHEDULE_WITHDRAW_MONEY_SWP,
                                                                label: 'SWP',
                                                                disabled: routeParams.type !== ROUTER_PARAM_WITHDRAW_TRANSACTIONS &&
                                                                    routeParams.type !== ROUTER_PARAM_ALL_TRANSACTIONS
                                                            },
                                                            {
                                                                value: TRANSACTION_TYPE_SWITCH_MONEY,
                                                                label: 'Switch',
                                                                disabled: routeParams.type !== ROUTER_PARAM_SWITCH_TRANSACTIONS &&
                                                                    routeParams.type !== ROUTER_PARAM_ALL_TRANSACTIONS
                                                            },
                                                            {
                                                                value: TRANSACTION_TYPE_TRANSFER_MONEY,
                                                                label: 'Transfer',
                                                                disabled: routeParams.type !== ROUTER_PARAM_TRANSFER_TRANSACTIONS &&
                                                                    routeParams.type !== ROUTER_PARAM_ALL_TRANSACTIONS
                                                            },
                                                            {
                                                                value: TRANSACTION_TYPE_DIVIDEND,
                                                                label: 'Dividend',
                                                                disabled: routeParams.type !== ROUTER_PARAM_ALL_TRANSACTIONS
                                                            }
                                                        ]}
                                                />
                                            </Form.Item>

                                        </Col>
                                        <Col xxl={6} xl={showSecondCol ? 12 : 6} lg={12} md={24}>
                                            <Form.Item label="Portfolio ID" name="portfolioId">
                                                <Input onKeyPress={Validation.isNumberWithDash}
                                                       placeholder="Enter portfolio id"/>
                                            </Form.Item>
                                        </Col>
                                        <Col xxl={6} xl={showSecondCol ? 12 : 6} lg={12} md={24}>
                                            <Form.Item label="CIN" name="cin"
                                                       rules={[{
                                                           required: isCINRequired,
                                                           message: 'Please enter CIN'
                                                       }]}
                                                       onChange={onCinChange}
                                            >
                                                <Input onKeyPress={Validation.isNumber}
                                                       placeholder="Enter CIN"/>
                                            </Form.Item>
                                        </Col>
                                        <Col xxl={6} xl={showSecondCol ? 12 : 6} lg={12} md={24}>
                                            <Form.Item label="Identification Value" name="identificationValue"
                                                       rules={[{
                                                           required: isIDRequired,
                                                           message: 'Please enter identification value'
                                                       }]}
                                                       onChange={onIDChange}
                                            >
                                                <Input onKeyPress={Validation.alphanumericAndNumbers}
                                                       placeholder="Enter identification value"/>
                                            </Form.Item>
                                        </Col>
                                        <Col xxl={6} xl={showSecondCol ? 12 : 6} lg={12} md={24}>
                                            {/*<Form.Item label="Amount" name="amount">*/}
                                            {/*    <Input onPaste={preventDefaultEvent}*/}
                                            {/*           maxLength={15}*/}
                                            {/*           onBlur={handleBlur}*/}
                                            {/*           placeholder={"Enter amount"}/>*/}
                                            {/*</Form.Item>*/}

                                            <Form.Item label="Amount" name="amount">
                                                <Input
                                                    onKeyPress={Validation.isNumberWithDashAndDot}
                                                    type="text"
                                                    onBlur={handleBlur}
                                                    onFocus={handleFocus}
                                                    autoComplete="off"
                                                    placeholder={"Enter amount"}/>
                                            </Form.Item>
                                        </Col>
                                        <Col xxl={6} xl={showSecondCol ? 12 : 6} lg={12} md={24}>
                                            <Form.Item label="Status" name="status">
                                                <Select style={{width: '100%'}} defaultValue="All"
                                                        onChange={onChangeStatus}
                                                        options={[
                                                            {value: null, label: 'All'},
                                                            {value: 'SUBMITTED', label: 'Submitted'},
                                                            {value: 'PROCESSING', label: 'Processing'},
                                                            {value: 'COMPLETED', label: 'Completed'},
                                                            {value: 'REJECTED', label: 'Rejected'},
                                                            {value: 'CANCELLED', label: 'Cancelled'}]}
                                                />
                                            </Form.Item>
                                        </Col>
                                        <Col xxl={6} xl={showSecondCol ? 12 : 6} lg={12} md={24}>
                                            {/*<Form.Item label="Transaction Date" name="submittedDate">*/}
                                            {/*    <RangePicker placeholder={["From Date", "To Date"]}*/}
                                            {/*                 style={{width: '100%'}}/>*/}

                                            {/*</Form.Item>*/}
                                            <Form.Item label="Transaction Date" name="submittedDate">
                                                <RangePicker placeholder={["From Date", "To Date"]}
                                                             allowClear={false}
                                                             style={{width: '100%'}}
                                                />

                                            </Form.Item>
                                        </Col>
                                        <Col xxl={6} xl={showSecondCol ? 12 : 6} lg={12} md={24}>
                                            <Form.Item label="Fund" name="fundId">
                                                <Select style={{width: '100%'}} placeholder={"Select fund"}
                                                        showSearch
                                                        optionFilterProp="children"
                                                        filterOption={(input: any, option: {
                                                            label: any;
                                                        }) => (option?.label.toLowerCase() ?? '').startsWith(input.toLowerCase())}
                                                        getPopupContainer={(trigger: {
                                                            parentNode: any;
                                                        }) => trigger.parentNode}
                                                        options={fundDropdownList}/>
                                            </Form.Item>

                                        </Col>
                                    </Row>
                                    <Row gutter={[16, 0]}>
                                        <Col span={24}>
                                            <div className="tr-filter-btns">
                                                <Button className={'tr-reset-btn'} icon={<ReloadOutlined/>}
                                                        htmlType={'reset'}>
                                                    Reset
                                                </Button>
                                                <Button className={'tr-search-btn'} type="primary"
                                                        htmlType={'submit'}
                                                        icon={<SearchOutlined/>}>
                                                    Search
                                                </Button>
                                            </div>
                                        </Col>
                                    </Row>
                                </Form>

                            </Panel>

                        </Collapse>
                    </Col>
                    <Col span={24}>
                        <Card>
                            <Table columns={columns} scroll={{x: 'max-content'}} dataSource={tableData}
                                   rowClassName={(record: any, index: number) => (index === selectedRowKey ? 'selected-row' : '')}
                                   loading={isLoading}/>
                        </Card>
                    </Col>
                </Row>

            </div>
            {showSecondCol && (
                <div className={`secondDiv${showSecondCol ? ' active' : ''}`}>
                    <Affix offsetTop={84}
                           className={`${nearBottom ? 'nearBottom' : ''} ${bottomReached ? 'bottomReached' : 'notBottomReached'}`}>
                        <Card className={'transaction-more-info-card'}
                              title={
                                  <>
                                      <div className="transaction_type_div">
                                          <div
                                              className={getCardIconByTransaction(rightSideSectionData.transactionTag)}>
                                              <div
                                                  className={getTransactionStatusIconClass(rightSideSectionData.status)}>
                                                  <div className="transfer-icon"></div>

                                              </div>
                                          </div>
                                          <div className="transaction_text">
                                                <span className="transaction_type">
                                                    {getTransactionTypeDisplayName(rightSideSectionData.transactionTag)}
                                                </span>
                                              <span className="transaction_date">Ref. No : <span
                                                  className={'bold-date-time'}>
                                                  {rightSideSectionData.accountWiseFundDetailDtos[0].transactionRefNo ?? "N/A"}</span></span>
                                          </div>
                                      </div>
                                  </>
                              }
                              extra={
                                  <div className="card-header-extra">
                                      {getStatusTag(rightSideSectionData.status)}
                                      <Button className={'close-more-info-card'} size="small"
                                              icon={<CloseOutlined/>} onClick={closeRightSideSection}>
                                      </Button>
                                  </div>
                              }
                        >


                            <>
                                {
                                    rightSideSectionData.transactionTag === TRANSACTION_TYPE_INVEST_MONEY ?

                                        investRightSideDocData() :
                                        rightSideSectionData.transactionTag === TRANSACTION_TYPE_WITHDRAW_MONEY ||
                                        rightSideSectionData.transactionTag === TRANSACTION_TYPE_SCHEDULE_WITHDRAW_MONEY ||
                                        rightSideSectionData.transactionTag === TRANSACTION_TYPE_SCHEDULE_WITHDRAW_MONEY_SWP ?

                                            getWithdrawRightSideDocData(
                                                rightSideSectionData.transactionTag === TRANSACTION_TYPE_SCHEDULE_WITHDRAW_MONEY ?
                                                    "Scheduled" : rightSideSectionData.transactionTag === TRANSACTION_TYPE_SCHEDULE_WITHDRAW_MONEY_SWP ?
                                                        "SWP" : "Online") :

                                            rightSideSectionData.transactionTag === TRANSACTION_TYPE_DIVIDEND ?
                                                dividendRightSideDocData() :

                                                rightSideSectionData.transactionTag === TRANSACTION_TYPE_SWITCH_MONEY ?
                                                    getSwitchRightSideDocData() :
                                                    getTransferRightSideDocData()

                                }
                                {
                                    rightSideSectionData.status === "REJECTED" && rightSideSectionData.transactionTag !== TRANSACTION_TYPE_INVEST_MONEY ?
                                        <>
                                            <Divider/>
                                            <Row className={'transaction_details'}>
                                                <Col span={24}>
                                                    <Statistic title="Reject Reason"
                                                               value={rightSideSectionData.rejectReason}/>
                                                </Col>

                                            </Row>
                                        </> : ''
                                }

                            </>


                        </Card>
                    </Affix>


                </div>
            )}

        </div>
        <Modal
            className={docType == PREVIEW_DOC_TYPES.PDF ? "modal-custom-bg" : "image-view-modal"}
            open={previewOpen}
            centered
            title={documentName}
            onCancel={handlePreviewCancel}
            destroyOnClose={true}
            width={docType == PREVIEW_DOC_TYPES.PDF ? 800 : 600}
            footer={[
                <Button type="primary" icon={<DownloadOutlined/>} style={{background: '#FF7400', height: 40}}
                        htmlType="submit" onClick={() => download(docURL, documentName)}>
                    Download
                </Button>]}>
            <PreviewModalComp docURL={docURL}/>
        </Modal>
    </>
}

export default AdminTransactionHistoryPage;